import React from 'react'
import moment from 'moment'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from './style'

import Summary from './partials/Summary'
import DailySummary from './partials/DailySummary'
import RevenueTable from './partials/RevenueTable'
import BillingTable from './partials/BillingTable'

import MonthGraph from './partials/MonthGraph'
import TopGeo from './partials/TopGeo'
import DateSelector from './partials/DateSelector'
import CommunitySelector from './partials/CommunitySelector'

import access from '../../utils/access'
import uRevenue from '../../utils/revenue'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Community', 'Stats', 'Payment', 'Config')
@observer
export class Statistics extends React.Component {
  componentWillMount () {
    const _date = moment()
    const params = {
      month: +_date.format('MM') - 1,
      year: _date.format('YYYY'),
      ...this.props.match.params
    }

    const dateString = moment({ year: params.year, month: params.month })
      .startOf('month')
      .format('YYYY-MM-DD')

    const comId = params.comId
    const _findReports = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findReports()
        }

        Promise.all([
          ...(access.adminCom(this.props.User.me.permissions || {})
            ? [this.props.Community.getAllCommunities()]
            : [this.props.Community.getMyCommunities()]),
          ...(comId
            ? [
              this.props.Stats.getTrafficReport(comId, dateString),
              this.props.Stats.getRevenueReport(comId, dateString),
              this.props.Payment.getRevenueReport(comId, dateString),
              this.props.Payment.getTransactionReport(comId, dateString)
            ]
            : [])
        ]).then(() => {
          if (!comId) {
            return Promise.all([
              ...(access.adminCom(this.props.User.me.permissions || {})
                ? [
                  this.props.Stats.getBatchTrafficReport(dateString),
                  this.props.Stats.getBatchRevenueReport(dateString),
                  this.props.Payment.getBatchRevenueReport(dateString)
                ]
                : [
                  ...this.props.Community.my
                      .slice()
                      .map(c => [
                        this.props.Stats.getTrafficReport(c.id, dateString),
                        this.props.Stats.getRevenueReport(c.id, dateString),
                        this.props.Payment.getRevenueReport(c.id, dateString),
                        this.props.Payment.getTransactionReport(
                          c.id,
                          dateString
                        )
                      ])
                ])
            ])
          }
        })
      }, 500)
    }

    _findReports()
  }

  onDateSelectChange (e) {
    const date = e.target.value.split('-')
    const dateString = `${date[0]}-${date[1]}-01`

    const params = this.props.match.params

    const _path = params.comId
      ? `/dashboard/statistics/:comId/${date[0]}/${+date[1] - 1}`
      : `/dashboard/statistics/${date[0]}/${+date[1] - 1}`

    const url = Object.keys(this.props.match.params).reduce(
      (_url, key) => _url.replace(`:${key}`, this.props.match.params[key]),
      _path
    )

    this.props.history.push(url)

    return Promise.all([
      ...(params.comId
        ? [
          this.props.Stats.getTrafficReport(params.comId, dateString),
          this.props.Stats.getRevenueReport(params.comId, dateString),
          this.props.Payment.getRevenueReport(params.comId, dateString),
          this.props.Payment.getTransactionReport(params.comId, dateString)
        ]
        : [
          ...(access.adminCom(this.props.User.me.permissions || {})
              ? [
                this.props.Stats.getBatchTrafficReport(dateString),
                this.props.Stats.getBatchRevenueReport(dateString),
                this.props.Payment.getBatchRevenueReport(dateString)
              ]
              : [
                ...this.props.Community.my
                    .slice()
                    .map(c => [
                      this.props.Stats.getTrafficReport(c.id, dateString),
                      this.props.Stats.getRevenueReport(c.id, dateString),
                      this.props.Payment.getRevenueReport(c.id, dateString),
                      this.props.Payment.getTransactionReport(c.id, dateString)
                    ])
              ])
        ])
    ])
  }

  onCommunitySelectChange (item) {
    const _date = moment()
    const params = {
      month: +_date.format('MM') - 1,
      year: _date.format('YYYY'),
      ...this.props.match.params
    }

    const dateString = moment({ year: params.year, month: params.month })
      .startOf('month')
      .format('YYYY-MM-DD')

    const _path =
      item.value && item.value !== '-1'
        ? params.year
          ? `/dashboard/statistics/${item.value}/:year/:month`
          : `/dashboard/statistics/${item.value}`
        : params.year
          ? `/dashboard/statistics/:year/:month`
          : `/dashboard/statistics/`

    const url = Object.keys(params).reduce(
      (_url, key) => _url.replace(`:${key}`, params[key]),
      _path
    )

    this.props.history.push(url)

    if (item.value && item.value !== '-1') {
      Promise.all([
        ...(!this.props.Stats.traffic[item.value]
          ? [this.props.Stats.getTrafficReport(item.value, dateString)]
          : []),
        ...(!this.props.Stats.revenue[item.value]
          ? [this.props.Stats.getRevenueReport(item.value, dateString)]
          : []),
        ...(!this.props.Payment.revenue[item.value]
          ? [this.props.Payment.getRevenueReport(item.value, dateString)]
          : []),
        ...(!this.props.Payment.transactions[item.value]
          ? [this.props.Payment.getTransactionReport(item.value, dateString)]
          : [])
      ])
    }
  }

  render () {
    const _date = moment()
    const params = {
      month: +_date.format('MM') - 1,
      year: _date.format('YYYY'),
      ...this.props.match.params
    }

    const community =
      this.props.Community.all.slice().find(c => c.id === params.comId) || {}

    const dateString = moment({ year: params.year, month: params.month })
      .startOf('month')
      .format('YYYY-MM-DD')

    const currentDate = new Date(
      moment({ year: params.year, month: params.month }).valueOf()
    )

    const startDate = params.comId
      ? moment(community.createdAt || Date.now())
      : this.props.Community.all
          .slice()
          .reduce(
            (d, c) =>
              d instanceof Date
                ? d > new Date(c.createdAt) ? moment(c.createdAt) : d
                : moment(c.createdAt),
            moment()
          )

    const statsToday = params.comId
      ? (() => {
        const s = (this.props.Stats.revenue[params.comId] || [])
            .slice()
            .find(s => s.date.slice(0, 10) === moment().format('YYYY-MM-DD'))
        return {
          ...(s
              ? { ...s, earnings: +s.impressions / 1000 * +s.eCPM }
              : { impressions: 0, queries: 0, clicks: 0, earnings: 0 })
        }
      })()
      : Object.keys(this.props.Stats.revenue)
          .reduce(
            (arr, key) => [...arr, ...(this.props.Stats.revenue[key] || [])],
            []
          )
          .reduce(
            (obj, s) => {
              if (s && s.date.slice(0, 10) === moment().format('YYYY-MM-DD')) {
                return {
                  ...obj,
                  impressions: obj.impressions + +s.impressions,
                  queries: obj.queries + +s.queries,
                  clicks: obj.clicks + +s.clicks,
                  earnings: +obj.earnings + +s.impressions / 1000 * +s.eCPM
                }
              }
              return obj
            },
        {
          impressions: 0,
          queries: 0,
          clicks: 0,
          earnings: 0
        }
          )

    const statsMonth = (params.comId
      ? (this.props.Stats.revenue[params.comId] || [])
          .slice()
          .filter(s => s.date.slice(0, 7) === dateString.slice(0, 7))
      : Object.keys(this.props.Stats.revenue).reduce(
          (arr, key) => [...arr, ...(this.props.Stats.revenue[key] || [])],
          []
        )
    ).reduce(
      (obj, s) => {
        if (s && s.date.slice(0, 7) === dateString.slice(0, 7)) {
          return {
            ...obj,
            impressions: +obj.impressions + +s.impressions,
            queries: +obj.queries + +s.queries,
            clicks: +obj.clicks + +s.clicks
          }
        }
        return obj
      },
      {
        impressions: 0,
        queries: 0,
        clicks: 0,
        earnings: 0
      }
    )

    const summedRevenue = (
      this.props.Payment.revenue[params.comId] || []
    ).reduce(uRevenue.reduceSumRevenue, [
      { total: 0, date: dateString, report: [] }
    ])

    const earningsMonth = params.comId
      ? summedRevenue[0].total
      : Object.keys(this.props.Payment.revenue || {})
          .reduce(
            (arr, key) => [...arr, ...this.props.Payment.revenue[key]],
            []
          )
          .reduce(
            (n, r) =>
              n +
              (r.date.slice(0, 7) === dateString.slice(0, 7) ? +r.total : 0),
            0
          )

    const earningsListMonth = params.comId
      ? summedRevenue[0].report.reduce((arr, r) => {
        const index = arr.findIndex(_r => _r.date === r.date)

        return [
          ...(index > -1
              ? [
                ...arr.slice(0, index),
                {
                  date: new Date(r.date).getTime(),
                  earnings: +r.amount + +arr[index].earnings
                }
              ]
              : [
                ...arr,
                {
                  date: new Date(r.date).getTime(),
                  earnings: +r.amount
                }
              ])
        ]
      }, [])
      : Object.keys(this.props.Payment.revenue)
          .reduce(
            (arr, key) => [
              ...arr,
              ...(
                this.props.Payment.revenue[key].find(
                  r => r.date.slice(0, 7) === dateString.slice(0, 7)
                ) || { report: [] }
              ).report
            ],
            []
          )
          .reduce((arr, r) => {
            const index = arr.findIndex(_r => _r.date === r.date)
            return [
              ...(index > -1
                ? [
                  ...arr.slice(0, index),
                  {
                    date: new Date(r.date).getTime(),
                    earnings: +r.amount + +arr[index].earnings
                  }
                ]
                : [
                  ...arr,
                  {
                    date: new Date(r.date).getTime(),
                    earnings: +r.amount
                  }
                ])
            ]
          }, [])

    const topGeo = params.comId
      ? (this.props.Stats.traffic[params.comId] || [])
          .slice()
          .reduce(
            (arr, t) => [
              ...arr,
              ...(t.date.slice(0, 7) === dateString.slice(0, 7) ? [t] : [])
            ],
            []
          )
      : Object.keys(this.props.Stats.traffic)
          .reduce(
            (arr, key) => [...arr, ...this.props.Stats.traffic[key].slice()],
            []
          )
          .reduce((arr, t) => {
            if (t.date.slice(0, 7) === dateString.slice(0, 7)) {
              const geoIndex = arr.findIndex(
                g => g.countryCode === t.countryCode
              )

              return [
                ...(geoIndex > -1
                  ? [
                    ...arr.slice(0, geoIndex),
                    t.id > arr[geoIndex].id ? t : arr[geoIndex],
                    ...arr.slice(geoIndex + 1)
                  ]
                  : [...arr, t])
              ]
            }

            return arr
          }, [])

    const stats = params.comId
      ? (this.props.Stats.revenue[params.comId] || []).slice()
      : Object.keys(this.props.Stats.revenue).reduce(
          (arr, key) => [
            ...arr,
            ...this.props.Stats.revenue[key].reduce(
              (_arr, s) => [
                ..._arr,
                ...(s.date.slice(0, 7) === dateString.slice(0, 7) ? [s] : [])
              ],
              []
            )
          ],
          []
        )

    const revenue = params.comId
      ? summedRevenue
      : Object.keys(this.props.Payment.revenue).reduce(
          (arr, key) => [
            ...arr,
            ...this.props.Payment.revenue[key].reduce(
              (_arr, r) => [
                ..._arr,
                ...(r.date.slice(0, 7) === dateString.slice(0, 7) ? [r] : [])
              ],
              []
            )
          ],
          []
        )

    const transactions = params.comId
      ? (this.props.Payment.transactions[params.comId] || []).slice()
      : Object.keys(this.props.Payment.transactions).reduce(
          (arr, key) => [
            ...arr,
            ...this.props.Payment.transactions[key].reduce(
              (_arr, r) => [
                ..._arr,
                ...(r.date.slice(0, 7) === dateString.slice(0, 7) ? [r] : [])
              ],
              []
            )
          ],
          []
        )

    const communityList = access.adminCom(this.props.User.me.permissions || {})
      ? this.props.Community.all.slice()
      : this.props.Community.my.slice()

    return [
      <div
        key={-1}
        style={{ opacity: +!!community.eCPM }}
        className={`d-none d-xl-block ${css(
          style.cpm.wrapper,
          style[THEME_LIST[this.props.Config.theme].name]
            ? style[THEME_LIST[this.props.Config.theme].name].cpm.wrapper
            : null
        )}`}
      >
        <Row>
          <Col
            className={`d-flex flex-column align-items-center justify-content-center`}
          >
            <span
              className={css(
                style.cpm.value,
                style[THEME_LIST[this.props.Config.theme].name]
                  ? style[THEME_LIST[this.props.Config.theme].name].cpm.value
                  : null
              )}
            >
              ${parseFloat(community.eCPM || 0).toFixed(2)}
            </span>
            <span
              className={css(
                style.cpm.label,
                style[THEME_LIST[this.props.Config.theme].name]
                  ? style[THEME_LIST[this.props.Config.theme].name].cpm.label
                  : null
              )}
            >
              eCPM
            </span>
          </Col>
        </Row>
      </div>,
      <Row key={0}>
        <Col xs='12' lg='6'>
          <Row>
            <Col xs='12' lg='6'>
              <DateSelector
                theme={THEME_LIST[this.props.Config.theme]}
                options={datesToMonthList(startDate, moment())}
                date={currentDate}
                value={dateString}
                onChange={this.onDateSelectChange.bind(this)}
              />
            </Col>
            <Col xs='12' lg='6'>
              <CommunitySelector
                theme={THEME_LIST[this.props.Config.theme]}
                options={communityList}
                value={params.comId || -1}
                onChange={this.onCommunitySelectChange.bind(this)}
              />
            </Col>
          </Row>
        </Col>
      </Row>,
      <Row key={1} className={css(style.row.row)}>
        <Col xs='12' lg='6' className={css(style.daily.wrapper)}>
          <DailySummary
            stats={statsToday}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
        <Col xs='12' lg='6'>
          <Summary
            date={currentDate}
            stats={{
              ...statsMonth,
              ...{ earnings: earningsMonth }
            }}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
      </Row>,
      <Row key={2} className={css(style.row.row)}>
        <Col xs='12' lg='6' className={css(style.graph.wrapper)}>
          <MonthGraph
            date={currentDate}
            stats={earningsListMonth}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
        <Col xs='12' lg='6' className={css(style.topgeo.wrapper)}>
          <TopGeo
            traffic={topGeo || []}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
      </Row>,
      <Row key={3} className={css(style.row.row)}>
        <Col xs='12'>
          <RevenueTable
            date={currentDate}
            stats={stats}
            revenue={revenue}
            transactions={transactions}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
      </Row>,
      <Row key={4} className={css(style.row.row)}>
        <Col xs='12'>
          <BillingTable
            date={currentDate}
            revenue={revenue}
            transactions={transactions}
            theme={THEME_LIST[this.props.Config.theme]}
          />
        </Col>
      </Row>
    ]
  }
}

const datesToMonthList = (a, b) => {
  const listOfMonths = Array.from(Array(b.diff(a, 'months') + 1).keys(), n =>
    moment(a)
      .add(n + 1, 'months')
      .startOf('month')
  )

  return listOfMonths.reduce((arr, date) => {
    return [...arr, { label: date.format('MMM - YYYY'), date: date.valueOf() }]
  }, [])
}

export default Statistics



// WEBPACK FOOTER //
// ./src/components/Statistics/index.js